import {
  CertificationActionKind,
  CertificationDialogAction,
  CertificationLinkAction,
} from "./Training.types";

export const isDialogAction = (
  actionId: CertificationActionKind
): actionId is CertificationDialogAction =>
  [
    "open-test",
    "purchase-test",
    "start-credential",
    "start-core-certification",
    "start-gold-certification",
    "start-elective-courses",
    "start-employee-courses",
  ].includes(actionId);

export const isLinkAction = (
  actionId: CertificationActionKind
): actionId is CertificationLinkAction =>
  [
    "visit-inductive-university",
    "view-training-schedule",
    "view-core-study-guide",
    "view-gold-study-guide",
    "learn-more-about-gold-tests",
    "submit-test",
  ].includes(actionId);
